import { rendermixAPI } from "@api/main";
import User from "@models/user";
import Cookies from "js-cookie";
import { action, computed, flow, makeObservable, observable } from "mobx";
import { wishlistStore, cartStore } from "./main";
import { analytics } from "../services/analytics";

// window.Cookies = Cookies;

export default class AuthStore {
  user: User | null = null;
  sessionToken?: string = Cookies.get("op_session_token");

  private _fetchUserPromise: Promise<User> | null = null;

  constructor() {
    makeObservable(this, {
      user: observable,
      sessionToken: observable,
      userId: computed,
      isAuthenticated: computed,
      userIdAndToken: computed,
      sessionKey: computed,
      logout: action,
      deleteSessionAndLogout: flow,
      fetchUser: flow,
    });
  }

  get userId() {
    return this.user?.id;
  }

  get isAuthenticated() {
    return this.sessionToken !== undefined;
  }

  get userIdAndToken() {
    if (this.sessionToken) {
      const str = atob(this.sessionToken);
      const [userid, token] = str.split(":");
      return { userid, token };
    }
    return { userid: "", token: "" };
  }

  get sessionKey() {
    const { userid, token } = this.userIdAndToken;
    return `user:${userid}:session:${token}`;
  }

  logout() {
    analytics.clearUser();
    this.sessionToken = undefined;
    this.user = null;
    wishlistStore.clearWishlist();
    cartStore.clearCart();
    Cookies.remove("op_session_token", {
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      path: "/",
    });
  }

  *deleteSessionAndLogout() {
    yield rendermixAPI.deleteSession(this.sessionKey);
    this.logout();
  }

  *fetchUser() {
    if (!this._fetchUserPromise) this._fetchUserPromise = rendermixAPI.getProfile();
    const promise = this._fetchUserPromise;
    try {
      const user: User = yield promise;
      this.user = user;
      analytics.identifyUser(user);
    } finally {
      if (this._fetchUserPromise === promise) this._fetchUserPromise = null;
    }
  }
}
